import React from 'react'
import { getFormValues, initialize, reset } from 'redux-form'

import {
  FORM_CUBICAJE_SILOS,
  FORM_FUMIGADO_SILOS,
  FORM_INICIO_LLENADO_SILOS,
  FORM_MODIFICACION_CUBICAJE_SILOS,
  FORM_MODIFICACION_FUMIGADO_SILOS,
  FORM_MODIFICACION_LLENADO_SILOS
} from '../../../config/forms'
import { TABLE_REPORTE_POR_SILOS } from '../../../config/tables'
import Movimiento from '../../../models/movimiento/movimientoService'
import Silo from '../../../models/silo/silo'
import { MovimientoUtils } from '../../../models/movimiento/movimientoUtils'
import { ConfirmDialogView } from '../../Forms/SharedComponents/containers/Dialog/ConfirmDialogView'
import OperacionesAltaCubicajeSiloDialog from '../containers/OperacionesAltaCubicajeSiloDialog'
import OperacionesAltaFumigadoSiloDialog from '../containers/OperacionesAltaFumigadoSiloDialog'
import OperacionesCubicajeSiloDialog from '../containers/OperacionesCubicajeSiloDialog'
import OperacionesFumigadoSiloDialog from '../containers/OperacionesFumigadoSiloDialog'
import OperacionesInicioLlenadoSiloDialog from '../containers/OperacionesInicioLlenadoSiloDialog'
import OperacionesModificacionCubicajeSiloDialog from '../containers/OperacionesModificacionCubicajeSiloDialog'
import OperacionesModificacionFumigadoSiloDialog from '../containers/OperacionesModificacionFumigadoSiloDialog'
import OperacionesModificacionLlenadoSiloDialog from '../containers/OperacionesModificacionLlenadoSiloDialog'

export const actualizarEstadoSilos = (cereal = null, variedad = null) => async (dispatch) => {
  dispatch({
    type: 'UPDATE_ESTADO_SILOS',
    loading: true
  })
  dispatch({
    type: 'UPDATE_ESTADO_SILOS',
    loading: false,
    silos: await Movimiento.getMovimiento(cereal, variedad)
  })
}

export function onIniciarLlenadoDialogoFormValuesChange (values, dispatch) {
  values.cereal && dispatch({
    type: 'UPDATE_CEREAL_DROPDOWN_ETIQUETA',
    cereal: values.cereal
  })
  values.cerealVariedad && dispatch({
    type: 'UPDATE_CEREAL_VARIEDAD_DROPDOWN_ETIQUETA',
    cerealVariedad: values.cerealVariedad
  })
}

export function showToast (message, id, title, error = false) {
  return dispatch => {
    const onClose = () => {
      dispatch({
        type: 'CLOSE_TOAST',
        id: id
      })
    }
    dispatch({
      type: 'OPEN_TOAST',
      id: id,
      show: true,
      error: error,
      title: title,
      message: message,
      onClose: onClose
    })
  }
}
export function etiquetaSeleccionada (etiqueta) {
  return async dispatch => {
    const color = await Movimiento.getColorDeEtiqueta(etiqueta)
    dispatch({
      type: 'UPDATE_COLOR_ETIQUETA',
      color
    })
  }
}

export function colorSeleccionado (color) {
  return async dispatch => {
    dispatch({
      type: 'UPDATE_COLOR_INICIO_LLENADO',
      color
    })
  }
}

export function updateTablaSilos (newState) {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState,
      id: TABLE_REPORTE_POR_SILOS
    })
  }
}

export function setEtiquetaAsNew (isNew) {
  return dispatch => {
    dispatch({
      type: 'UPDATE_ETIQUETA_NEW',
      isNew
    })
  }
}

async function getSilosVigentes () {
  return Movimiento.getMovimiento()
}

export function parseData (data) {
  return MovimientoUtils.parseData(data)
}

export function openDialogOperacionesHabilitarSilo (silo) {
  return (dispatch) => {
    dispatch({
      type: 'UPDATE_SILO_OPERANDO',
      silo: silo
    })
    const cancelCallback = () => {
      dispatch({
        type: 'CLOSE_DIALOG',
        id: 'OPERAR_SILO_HABILITAR'
      })
    }
    dispatch({
      type: 'OPEN_DIALOG',
      id: 'OPERAR_SILO_MOVIMIENTO',
      maxWidth: 'xs',
      // content: <OperacionesHabilitarSiloDialog />,
      content: '',
      cancelCallback
    })
  }
}

export function openDialogOperacionesFumigadoSilo (silo) {
  return (dispatch) => {
    dispatch({
      type: 'UPDATE_SILO_OPERANDO',
      silo: silo
    })
    const cancelCallback = () => {
      dispatch({
        type: 'CLOSE_DIALOG',
        id: 'OPERAR_SILO_FUMIGADO'
      })
    }
    dispatch({
      type: 'OPEN_DIALOG',
      id: 'OPERAR_SILO_FUMIGADO',
      maxWidth: 'xs',
      content: <OperacionesFumigadoSiloDialog />,
      cancelCallback
    })
  }
}

export function openDialogOperacionesCubicajeSilo (silo) {
  return (dispatch) => {
    dispatch({
      type: 'UPDATE_SILO_OPERANDO',
      silo: silo
    })
    const cancelCallback = () => {
      dispatch({
        type: 'CLOSE_DIALOG',
        id: 'OPERAR_SILO_CUBICAJE'
      })
    }
    dispatch({
      type: 'OPEN_DIALOG',
      id: 'OPERAR_SILO_CUBICAJE',
      maxWidth: 'xs',
      content: <OperacionesCubicajeSiloDialog />,
      cancelCallback
    })
  }
}

export function openDialogInicioLlenado (silo) {
  return (dispatch, getState) => {
    const cancelCallback = () => {
      dispatch({
        type: 'CLOSE_DIALOG',
        id: 'INICIO_LLENADO_SILO'
      })
    }
    const confirmCallback = () => {
      const state = getState()
      const formValues = getFormValues(FORM_INICIO_LLENADO_SILOS)(state)
      if (!formValues || !formValues.cereal || formValues.cereal.trim() === 'UNDEF') {
        showToast(`Error iniciando llenado: Debe Completar El Cereal`, 'InicioLlenadoIncorrecto', 'InicioLlenado', true)(dispatch)
        dispatch(reset(FORM_INICIO_LLENADO_SILOS))
        return
      }
      const isNewEtiqueta = state.movimientoSilos.isNewEtiqueta
      const color = isNewEtiqueta ? (formValues.color ? formValues.color : '#000000') : state.movimientoSilos.colorEtiqueta
      const etiqueta = isNewEtiqueta ? formValues.newEtiqueta : formValues.etiqueta

      console.log('Etiqueta', etiqueta)
      Movimiento.inicioLlenado({
        silo: silo.nombreCorto,
        cereal: formValues.cereal ? formValues.cereal.trim() : formValues.cereal,
        cerealVariedad: formValues.cerealVariedad ? formValues.cerealVariedad.trim() : formValues.cerealVariedad,
        etiqueta,
        color
      }).then(() => {
        dispatch({
          type: 'CLOSE_DIALOG',
          id: 'INICIO_LLENADO_SILO'
        })
        dispatch({
          type: 'CLOSE_DIALOG',
          id: 'OPERAR_SILO_MOVIMIENTO'
        })
        showToast('Inicio de llenado correcto', 'inicioLlenadoCorrecto', 'Llenando')(dispatch)
        // clearCurrentSilo()(dispatch)
        getSilosVigentes().then(data => {
          const dataSilosParaGrafico = MovimientoUtils.parseDataForCuadroDeMando(data)
          dispatch({
            type: 'UPDATE_SILOS_D3_VIEW',
            loading: false,
            data: dataSilosParaGrafico
          })
          updateTablaSilos({
            data: parseData(data),
            title: 'Silos',
            isLoading: false
            // extraOptions: { searchText }
          })(
            dispatch
          )
        })
      })
        .catch(error => {
          dispatch({
            type: 'CLOSE_DIALOG',
            id: 'INICIO_LLENADO_SILO'
          })
          showToast(`Error iniciando llenado: ${error}`, 'inicioLlenadoIncorrecto', 'InicioLlenado', true)(dispatch)
        })
    }
    dispatch({
      type: 'OPEN_DIALOG',
      id: 'INICIO_LLENADO_SILO',
      maxWidth: 'xs',
      content: <OperacionesInicioLlenadoSiloDialog />,
      cancelCallback,
      confirmCallback
    })
  }
}

export function openDialogModificacionLlenado (silo) {
  return (dispatch, getState) => {
    const cancelCallback = () => {
      dispatch({
        type: 'CLOSE_DIALOG',
        id: 'MODIFICACION_LLENADO_SILO'
      })
    }
    const confirmCallback = () => {
      const state = getState()
      const formValues = getFormValues(FORM_MODIFICACION_LLENADO_SILOS)(state)
      const isNewEtiqueta = state.movimientoSilos.isNewEtiqueta
      const color = isNewEtiqueta ? (formValues.color ? formValues.color : '#000000') : state.movimientoSilos.colorEtiqueta
      const etiqueta = isNewEtiqueta ? formValues.newEtiqueta : formValues.etiqueta
      Movimiento.modificarLlenado({
        silo: silo.nombreCorto,
        cereal: silo.cereal,
        cerealVariedad: silo.cerealVariedad,
        fechaInicioLlenado: silo.fechaInicioLlenado,
        etiqueta: etiqueta,
        color: color
      }).then(() => {
        dispatch({
          type: 'CLOSE_DIALOG',
          id: 'MODIFICACION_LLENADO_SILO'
        })
        dispatch({
          type: 'CLOSE_DIALOG',
          id: 'OPERAR_SILO_MOVIMIENTO'
        })
        showToast('Modificacion de llenado correcta', 'modificacionLlenadoCorrecto', 'Modificacion')(dispatch)
        // clearCurrentSilo()(dispatch)
        getSilosVigentes().then(data => {
          const dataSilosParaGrafico = MovimientoUtils.parseDataForCuadroDeMando(data)
          dispatch({
            type: 'UPDATE_SILOS_D3_VIEW',
            loading: false,
            data: dataSilosParaGrafico
          })
          const parsedData = parseData(data)
          updateTablaSilos({
            data: parsedData,
            title: 'Silos',
            isLoading: false
          })(
            dispatch
          )
        })
      })
        .catch(error => {
          dispatch({
            type: 'CLOSE_DIALOG',
            id: 'MODIFICACION_LLENADO_SILO'
          })
          showToast(`Error modificando llenado: ${error}`, 'modificacionLlenadoIncorrecto', 'ModificacionLlenado', true)(dispatch)
        })
    }
    dispatch({
      type: 'OPEN_DIALOG',
      id: 'MODIFICACION_LLENADO_SILO',
      maxWidth: 'xs',
      content: <OperacionesModificacionLlenadoSiloDialog />,
      cancelCallback,
      confirmCallback
    })
    const { etiqueta } = silo
    const estadoSilo = { etiqueta }
    dispatch(
      initialize(FORM_MODIFICACION_LLENADO_SILOS, estadoSilo)
    )
  }
}

export function openDialogModificacionFumigado (silo) {
  return (dispatch, getState) => {
    const cancelCallback = () => {
      dispatch({
        type: 'CLOSE_DIALOG',
        id: 'MODIFICACION_FUMIGADO_SILO'
      })
    }
    const confirmCallback = () => {
      const state = getState()
      const formValues = getFormValues(FORM_MODIFICACION_FUMIGADO_SILOS)(state)
      // if (!formValues || !formValues.cereal || formValues.cereal.trim() === 'UNDEF') {
      //   showToast(`Error iniciando llenado: Debe Completar El Cereal`, 'InicioLlenadoIncorrecto', 'InicioLlenado', true)(dispatch)
      //   dispatch(reset(FORM_INICIO_LLENADO_SILOS))
      //   return
      // }
      Movimiento.modificarFumigado({
        silo: silo.nombreCorto,
        cereal: silo.cereal,
        cerealVariedad: silo.cerealVariedad,
        fechaUltimoFumigado: silo.fechaUltimoFumigado,
        producto: formValues.producto,
        observaciones: formValues.observaciones
      }).then(() => {
        dispatch({
          type: 'CLOSE_DIALOG',
          id: 'MODIFICACION_FUMIGADO_SILO'
        })
        dispatch({
          type: 'CLOSE_DIALOG',
          id: 'OPERAR_SILO_FUMIGADO'
        })
        showToast('Modificacion de fumigado correcta', 'modificacionFumigadoCorrecto', 'Modificacion')(dispatch)
        // clearCurrentSilo()(dispatch)
        getSilosVigentes().then(data => {
          const dataSilosParaGrafico = MovimientoUtils.parseDataForCuadroDeMando(data)
          dispatch({
            type: 'UPDATE_SILOS_D3_VIEW',
            loading: false,
            data: dataSilosParaGrafico
          })
          updateTablaSilos({
            data: parseData(data),
            title: 'Silos',
            isLoading: false
            // extraOptions: { searchText }
          })(
            dispatch
          )
        })
      })
        .catch(error => {
          dispatch({
            type: 'CLOSE_DIALOG',
            id: 'MODIFICACION_FUMIGADO_SILO'
          })
          showToast(`Error modificando fumigado: ${error}`, 'modificacionFumigadoIncorrecto', 'ModificacionFumigado', true)(dispatch)
        })
    }
    Movimiento.getFumigado({
      silo: silo.nombreCorto,
      cereal: silo.cereal,
      cerealVariedad: silo.cerealVariedad,
      fechaUltimoFumigado: silo.fechaUltimoFumigado
    }).then(fumigado => {
      dispatch({
        type: 'OPEN_DIALOG',
        id: 'MODIFICACION_FUMIGADO_SILO',
        maxWidth: 'xs',
        content: <OperacionesModificacionFumigadoSiloDialog />,
        cancelCallback,
        confirmCallback
      })
      const { observaciones, producto } = fumigado
      const estadoSilo = { observaciones, producto }
      dispatch(
        initialize(FORM_MODIFICACION_FUMIGADO_SILOS, estadoSilo)
      )
    })
  }
}

export function openDialogModificacionCubicaje (silo) {
  return (dispatch, getState) => {
    const cancelCallback = () => {
      dispatch({
        type: 'CLOSE_DIALOG',
        id: 'MODIFICACION_CUBICAJE_SILO'
      })
    }
    const confirmCallback = () => {
      const state = getState()
      const formValues = getFormValues(FORM_MODIFICACION_CUBICAJE_SILOS)(state)
      // if (!formValues || !formValues.cereal || formValues.cereal.trim() === 'UNDEF') {
      //   showToast(`Error iniciando llenado: Debe Completar El Cereal`, 'InicioLlenadoIncorrecto', 'InicioLlenado', true)(dispatch)
      //   dispatch(reset(FORM_INICIO_LLENADO_SILOS))
      //   return
      // }
      Movimiento.modificarCubicaje({
        silo: silo.nombreCorto,
        cereal: silo.cereal,
        cerealVariedad: silo.cerealVariedad,
        fechaUltimoCubicaje: silo.fechaUltimoCubicaje,
        metrosDeVacio: formValues.metrosDeVacio,
        ph: formValues.ph
      }).then(() => {
        dispatch({
          type: 'CLOSE_DIALOG',
          id: 'MODIFICACION_CUBICAJE_SILO'
        })
        dispatch({
          type: 'CLOSE_DIALOG',
          id: 'OPERAR_SILO_CUBICAJE'
        })
        showToast('Modificacion de cubicaje correcta', 'modificacionCubicajeCorrecto', 'Modificacion')(dispatch)
        // clearCurrentSilo()(dispatch)
        getSilosVigentes().then(data => {
          const dataSilosParaGrafico = MovimientoUtils.parseDataForCuadroDeMando(data)
          dispatch({
            type: 'UPDATE_SILOS_D3_VIEW',
            loading: false,
            data: dataSilosParaGrafico
          })
          const parsedData = parseData(data)
          updateTablaSilos({
            data: parsedData,
            title: 'Silos',
            isLoading: false
          })(
            dispatch
          )
        })
      })
        .catch(error => {
          dispatch({
            type: 'CLOSE_DIALOG',
            id: 'MODIFICACION_CUBICAJE_SILO'
          })
          showToast(`Error modificando cubicaje: ${error}`, 'modificacionCubicajeIncorrecto', 'ModificacionCubicaje', true)(dispatch)
        })
    }
    Movimiento.getCubicaje({
      silo: silo.nombreCorto,
      cereal: silo.cereal,
      cerealVariedad: silo.cerealVariedad,
      fechaUltimoCubicaje: silo.fechaUltimoCubicaje
    }).then(cubicaje => {
      dispatch({
        type: 'OPEN_DIALOG',
        id: 'MODIFICACION_CUBICAJE_SILO',
        maxWidth: 'xs',
        content: <OperacionesModificacionCubicajeSiloDialog />,
        cancelCallback,
        confirmCallback
      })
      const { metrosDeVacio, ph } = cubicaje
      const estadoSilo = { metrosDeVacio, ph }
      dispatch(
        initialize(FORM_MODIFICACION_CUBICAJE_SILOS, estadoSilo)
      )
    })
  }
}

export function openDialogNuevoFumigado (silo) {
  return (dispatch, getState) => {
    const cancelCallback = () => {
      dispatch({
        type: 'CLOSE_DIALOG',
        id: 'FUMIGADO_SILO'
      })
    }
    const confirmCallback = () => {
      const state = getState()
      const formValues = getFormValues(FORM_FUMIGADO_SILOS)(state) || {}
      // if (!formValues) {
      //   showToast(`Error iniciando llenado: Debe Completar Todos Los Campos`, 'InicioLlenadoIncorrecto', 'InicioLlenado', true)(dispatch)
      //   dispatch(reset(FORM_MOVIMIENTOS_SILOS))
      //   return
      // }
      // const currentSilo = state.movimientoSilos.siloOperando
      Movimiento.fumigar({
        silo: silo.nombreCorto,
        cereal: silo.cereal,
        cerealVariedad: silo.cerealVariedad,
        producto: formValues.producto,
        observaciones: formValues.observaciones
      })
        .then(() => {
          dispatch({
            type: 'CLOSE_DIALOG',
            id: 'FUMIGADO_SILO'
          })
          dispatch({
            type: 'CLOSE_DIALOG',
            id: 'OPERAR_SILO_FUMIGADO'
          })
          showToast('Fumigado correcto', 'fumigadoCorrecto', 'Fumigado')(dispatch)
          // clearCurrentSilo()(dispatch)
          getSilosVigentes().then(data => {
            const dataSilosParaGrafico = MovimientoUtils.parseDataForCuadroDeMando(data)
            dispatch({
              type: 'UPDATE_SILOS_D3_VIEW',
              loading: false,
              data: dataSilosParaGrafico
            })
            updateTablaSilos({
              data: parseData(data),
              title: 'Silos',
              isLoading: false
              // extraOptions: { searchText }
            })(
              dispatch
            )
          })
        })
        .catch(error => {
          dispatch({
            type: 'CLOSE_DIALOG',
            id: 'FUMIGADO_SILO'
          })
          showToast(`Error fumigando: ${error}`, 'fumigadoIncorrecto', 'Fumigado', true)(dispatch)
        })
    }
    dispatch({
      type: 'OPEN_DIALOG',
      id: 'FUMIGADO_SILO',
      maxWidth: 'xs',
      content: <OperacionesAltaFumigadoSiloDialog />,
      cancelCallback,
      confirmCallback
    })
  }
}

export function openDialogNuevoCubicaje (silo) {
  return (dispatch, getState) => {
    const cancelCallback = () => {
      dispatch({
        type: 'CLOSE_DIALOG',
        id: 'CUBICAJE_SILO'
      })
    }
    const confirmCallback = () => {
      const state = getState()
      const formValues = getFormValues(FORM_CUBICAJE_SILOS)(state) || {}
      if (!formValues || !formValues.metrosDeVacio) {
        showToast(`Error cubicando llenado: Debe Completar los metros de vacio`, 'CubicajeIncorrecto', 'Cubicaje', true)(dispatch)
        dispatch(reset(FORM_CUBICAJE_SILOS))
        return
      }
      // const currentSilo = state.movimientoSilos.siloOperando
      Movimiento.cubicar({
        silo: silo.nombreCorto,
        cereal: silo.cereal,
        cerealVariedad: silo.cerealVariedad,
        metros_de_vacio: formValues.metrosDeVacio,
        ph: formValues.ph
      })
        .then(() => {
          dispatch({
            type: 'CLOSE_DIALOG',
            id: 'CUBICAJE_SILO'
          })
          dispatch({
            type: 'CLOSE_DIALOG',
            id: 'OPERAR_SILO_CUBICAJE'
          })
          showToast('Cubicaje correcto', 'cubicajeCorrecto', 'Cubicaje')(dispatch)
          // clearCurrentSilo()(dispatch)
          getSilosVigentes().then(data => {
            const dataSilosParaGrafico = MovimientoUtils.parseDataForCuadroDeMando(data)
            dispatch({
              type: 'UPDATE_SILOS_D3_VIEW',
              loading: false,
              data: dataSilosParaGrafico
            })
            const parsedData = parseData(data)
            updateTablaSilos({
              data: parsedData,
              title: 'Silos',
              isLoading: false
            })(
              dispatch
            )
          })
        })
        .catch(error => {
          dispatch({
            type: 'CLOSE_DIALOG',
            id: 'CUBICAJE_SILO'
          })
          showToast(`Error cubicando: ${error}`, 'CubicajeIncorrecto', 'Cubicaje', true)(dispatch)
        })
    }
    dispatch({
      type: 'OPEN_DIALOG',
      id: 'CUBICAJE_SILO',
      maxWidth: 'xs',
      content: <OperacionesAltaCubicajeSiloDialog />,
      cancelCallback,
      confirmCallback
    })
  }
}

export function openDialogFinLlenado (silo) {
  return (dispatch) => {
    const cancelCallback = () => {
      dispatch({
        type: 'CLOSE_DIALOG',
        id: 'FIN_LLENADO_SILO'
      })
    }
    const confirmCallback = () => {
      Movimiento.finalizarLlenado(silo).then(() => {
        dispatch({
          type: 'CLOSE_DIALOG',
          id: 'FIN_LLENADO_SILO'
        })
        dispatch({
          type: 'CLOSE_DIALOG',
          id: 'OPERAR_SILO_MOVIMIENTO'
        })
        showToast('Fin de llenado correcto', 'finLlenadoCorrecto', 'Lleno')(dispatch)
        getSilosVigentes().then(data => {
          const dataSilosParaGrafico = MovimientoUtils.parseDataForCuadroDeMando(data)
          dispatch({
            type: 'UPDATE_SILOS_D3_VIEW',
            loading: false,
            data: dataSilosParaGrafico
          })
          const parsedData = parseData(data)
          updateTablaSilos({
            data: parsedData,
            title: 'Silos',
            isLoading: false
          })(
            dispatch
          )
        })
      })
        .catch(error => {
          dispatch({
            type: 'CLOSE_DIALOG',
            id: 'FIN_LLENADO_SILO'
          })
          showToast(`Error finalizando llenado: ${error}`, 'finLlenadoIncorrecto', 'finLlenado', true)(dispatch)
        })
    }
    dispatch({
      type: 'OPEN_DIALOG',
      id: 'FIN_LLENADO_SILO',
      maxWidth: 'xs',
      content: <ConfirmDialogView text={'¿Esta seguro que desea finalizar el llenado?'} />,
      cancelCallback,
      confirmCallback
    })
  }
}

export function openDialogEliminarInicioLlenado (silo) {
  return (dispatch) => {
    const cancelCallback = () => {
      dispatch({
        type: 'CLOSE_DIALOG',
        id: 'ANULAR_INICIO_LLENADO_SILO'
      })
    }
    const confirmCallback = () => {
      Movimiento.anularInicioLlenado(silo).then(() => {
        dispatch({
          type: 'CLOSE_DIALOG',
          id: 'ANULAR_INICIO_LLENADO_SILO'
        })
        dispatch({
          type: 'CLOSE_DIALOG',
          id: 'OPERAR_SILO_MOVIMIENTO'
        })
        showToast('anulacion de inicio de llenado correcto', 'anulacionInicioLlenadoCorrecto', 'Anulacion')(dispatch)
        getSilosVigentes().then(data => {
          const dataSilosParaGrafico = MovimientoUtils.parseDataForCuadroDeMando(data)
          dispatch({
            type: 'UPDATE_SILOS_D3_VIEW',
            loading: false,
            data: dataSilosParaGrafico
          })
          const parsedData = parseData(data)
          updateTablaSilos({
            data: parsedData,
            title: 'Silos',
            isLoading: false
          })(
            dispatch
          )
        })
      })
        .catch(error => {
          dispatch({
            type: 'CLOSE_DIALOG',
            id: 'ANULAR_INICIO_LLENADO_SILO'
          })
          showToast(`Error anulando inicio de llenado: ${error}`, 'anularInicioLlenadoIncorrecto', 'Anulacion', true)(dispatch)
        })
    }
    dispatch({
      type: 'OPEN_DIALOG',
      id: 'ANULAR_INICIO_LLENADO_SILO',
      maxWidth: 'xs',
      content: <ConfirmDialogView text={'¿Esta seguro que desea anular el ultimo inicio de llenado?'} />,
      cancelCallback,
      confirmCallback
    })
  }
}

export function openDialogEliminarUltimoVaciado (silo) {
  return (dispatch) => {
    const cancelCallback = () => {
      dispatch({
        type: 'CLOSE_DIALOG',
        id: 'ANULAR_VACIADO_SILO'
      })
    }
    const confirmCallback = () => {
      Movimiento.anularVaciado(silo).then(() => {
        dispatch({
          type: 'CLOSE_DIALOG',
          id: 'ANULAR_VACIADO_SILO'
        })
        dispatch({
          type: 'CLOSE_DIALOG',
          id: 'OPERAR_SILO_MOVIMIENTO'
        })
        showToast('anulacion de vaciado correcto', 'anulacionVaciadooCorrecto', 'Anulacion')(dispatch)
        getSilosVigentes().then(data => {
          const dataSilosParaGrafico = MovimientoUtils.parseDataForCuadroDeMando(data)
          dispatch({
            type: 'UPDATE_SILOS_D3_VIEW',
            loading: false,
            data: dataSilosParaGrafico
          })
          const parsedData = parseData(data)
          updateTablaSilos({
            data: parsedData,
            title: 'Silos',
            isLoading: false
          })(
            dispatch
          )
        })
      })
        .catch(error => {
          dispatch({
            type: 'CLOSE_DIALOG',
            id: 'ANULAR_VACIADO_SILO'
          })
          showToast(`Error anulando vaciado: ${error}`, 'anularVaciadoIncorrecto', 'Anulacion', true)(dispatch)
        })
    }
    dispatch({
      type: 'OPEN_DIALOG',
      id: 'ANULAR_VACIADO_SILO',
      maxWidth: 'xs',
      content: <ConfirmDialogView text={'¿Esta seguro que desea anular el ultimo vaciado?'} />,
      cancelCallback,
      confirmCallback
    })
  }
}

export function openDialogEliminarUltimoFumigado (silo) {
  return (dispatch) => {
    const cancelCallback = () => {
      dispatch({
        type: 'CLOSE_DIALOG',
        id: 'ANULAR_FUMIGADO_SILO'
      })
    }
    const confirmCallback = () => {
      Movimiento.anularFumigado(silo).then(() => {
        dispatch({
          type: 'CLOSE_DIALOG',
          id: 'ANULAR_FUMIGADO_SILO'
        })
        dispatch({
          type: 'CLOSE_DIALOG',
          id: 'OPERAR_SILO_FUMIGADO'
        })
        showToast('anulacion de fumigado correcta', 'anulacionFumigadoCorrecto', 'Anulacion')(dispatch)
        getSilosVigentes().then(data => {
          const dataSilosParaGrafico = MovimientoUtils.parseDataForCuadroDeMando(data)
          dispatch({
            type: 'UPDATE_SILOS_D3_VIEW',
            loading: false,
            data: dataSilosParaGrafico
          })
          const parsedData = parseData(data)
          updateTablaSilos({
            data: parsedData,
            title: 'Silos',
            isLoading: false
          })(
            dispatch
          )
        })
      })
        .catch(error => {
          dispatch({
            type: 'CLOSE_DIALOG',
            id: 'ANULAR_FUMIGADO_SILO'
          })
          showToast(`Error anulando fumigado: ${error}`, 'anularFumigadoIncorrecto', 'Anulacion', true)(dispatch)
        })
    }
    dispatch({
      type: 'OPEN_DIALOG',
      id: 'ANULAR_FUMIGADO_SILO',
      maxWidth: 'xs',
      content: <ConfirmDialogView text={'¿Esta seguro que desea anular el ultimo fumigado?'} />,
      cancelCallback,
      confirmCallback
    })
  }
}

export function openDialogEliminarUltimoCubicaje (silo) {
  return (dispatch) => {
    const cancelCallback = () => {
      dispatch({
        type: 'CLOSE_DIALOG',
        id: 'ANULAR_CUBICAJE_SILO'
      })
    }
    const confirmCallback = () => {
      Movimiento.anularCubicaje(silo).then(() => {
        dispatch({
          type: 'CLOSE_DIALOG',
          id: 'ANULAR_CUBICAJE_SILO'
        })
        dispatch({
          type: 'CLOSE_DIALOG',
          id: 'OPERAR_SILO_CUBICAJE'
        })
        showToast('anulacion de fumigado correcta', 'anulacionFumigadoCorrecto', 'Anulacion')(dispatch)
        getSilosVigentes().then(data => {
          const dataSilosParaGrafico = MovimientoUtils.parseDataForCuadroDeMando(data)
          dispatch({
            type: 'UPDATE_SILOS_D3_VIEW',
            loading: false,
            data: dataSilosParaGrafico
          })
          const parsedData = parseData(data)
          updateTablaSilos({
            data: parsedData,
            title: 'Silos',
            isLoading: false
          })(
            dispatch
          )
        })
      })
        .catch(error => {
          dispatch({
            type: 'CLOSE_DIALOG',
            id: 'ANULAR_CUBICAJE_SILO'
          })
          showToast(`Error anulando cubicaje: ${error}`, 'anularCubicajeIncorrecto', 'Anulacion', true)(dispatch)
        })
    }
    dispatch({
      type: 'OPEN_DIALOG',
      id: 'ANULAR_CUBICAJE_SILO',
      maxWidth: 'xs',
      content: <ConfirmDialogView text={'¿Esta seguro que desea anular el ultimo cubicaje?'} />,
      cancelCallback,
      confirmCallback
    })
  }
}

export function openDialogEliminarFinLlenado (silo) {
  return (dispatch) => {
    const cancelCallback = () => {
      dispatch({
        type: 'CLOSE_DIALOG',
        id: 'ANULAR_FIN_LLENADO_SILO'
      })
    }
    const confirmCallback = () => {
      Movimiento.anularFinalizarLlenado(silo).then(() => {
        dispatch({
          type: 'CLOSE_DIALOG',
          id: 'ANULAR_FIN_LLENADO_SILO'
        })
        dispatch({
          type: 'CLOSE_DIALOG',
          id: 'OPERAR_SILO_MOVIMIENTO'
        })
        showToast('anulacion de fin de llenado correcto', 'anulacionFinLlenadoCorrecto', 'Anulacion')(dispatch)
        getSilosVigentes().then(data => {
          const dataSilosParaGrafico = MovimientoUtils.parseDataForCuadroDeMando(data)
          dispatch({
            type: 'UPDATE_SILOS_D3_VIEW',
            loading: false,
            data: dataSilosParaGrafico
          })
          const parsedData = parseData(data)
          updateTablaSilos({
            data: parsedData,
            title: 'Silos',
            isLoading: false
          })(
            dispatch
          )
        })
      })
        .catch(error => {
          dispatch({
            type: 'CLOSE_DIALOG',
            id: 'ANULAR_FIN_LLENADO_SILO'
          })
          showToast(`Error anulando fin de llenado: ${error}`, 'anularFinLlenadoIncorrecto', 'Anulacion', true)(dispatch)
        })
    }
    dispatch({
      type: 'OPEN_DIALOG',
      id: 'ANULAR_FIN_LLENADO_SILO',
      maxWidth: 'xs',
      content: <ConfirmDialogView text={'¿Esta seguro que desea anular el ultimo fin de llenado?'} />,
      cancelCallback,
      confirmCallback
    })
  }
}

export function openDialogVaciado (silo) {
  return (dispatch) => {
    const cancelCallback = () => {
      dispatch({
        type: 'CLOSE_DIALOG',
        id: 'VACIADO_SILO'
      })
    }
    const confirmCallback = () => {
      Movimiento.vaciar(silo).then(() => {
        dispatch({
          type: 'CLOSE_DIALOG',
          id: 'VACIADO_SILO'
        })
        dispatch({
          type: 'CLOSE_DIALOG',
          id: 'OPERAR_SILO_MOVIMIENTO'
        })
        showToast('Vaciado correcto', 'vaciadoCorrecto', 'Vaciado')(dispatch)
        getSilosVigentes().then(data => {
          const dataSilosParaGrafico = MovimientoUtils.parseDataForCuadroDeMando(data)
          dispatch({
            type: 'UPDATE_SILOS_D3_VIEW',
            loading: false,
            data: dataSilosParaGrafico
          })
          const parsedData = parseData(data)
          updateTablaSilos({
            data: parsedData,
            title: 'Silos',
            isLoading: false
          })(
            dispatch
          )
        })
      })
        .catch(error => {
          dispatch({
            type: 'CLOSE_DIALOG',
            id: 'VACIADO_SILO'
          })
          showToast(`Error vaciando: ${error}`, 'vaciadoIncorrecto', 'vaciado', true)(dispatch)
        })
    }
    dispatch({
      type: 'OPEN_DIALOG',
      id: 'VACIADO_SILO',
      maxWidth: 'xs',
      content: <ConfirmDialogView text={'¿Esta seguro que desea vaciar el silo?'} />,
      cancelCallback,
      confirmCallback
    })
  }
}

export function cambiarEstado (silo) {
  return dispatch => {
    const cancelCallback = () => {
      dispatch({
        type: 'CLOSE_DIALOG',
        id: 'CAMBIO_ESTADO_SILO'
      })
    }
    const confirmCallback = () => {
      console.log('Cambiando estado del silo', silo)
      Silo.cambiarEstado(silo).then(() => {
        dispatch({
          type: 'CLOSE_DIALOG',
          id: 'CAMBIO_ESTADO_SILO'
        })
        dispatch({
          type: 'CLOSE_DIALOG',
          id: 'OPERAR_SILO_MOVIMIENTO'
        })
        showToast('Cambio de estado correcto', 'cambioEstadoCorrecto', 'Cambio de estado')(dispatch)
        getSilosVigentes().then(data => {
          const dataSilosParaGrafico = MovimientoUtils.parseDataForCuadroDeMando(data)
          dispatch({
            type: 'UPDATE_SILOS_D3_VIEW',
            loading: false,
            data: dataSilosParaGrafico
          })
          const parsedData = parseData(data)
          updateTablaSilos({
            data: parsedData,
            title: 'Silos',
            isLoading: false
          })(
            dispatch
          )
        })
      })
        .catch(error => {
          dispatch({
            type: 'CLOSE_DIALOG',
            id: 'CAMBIO_ESTADO_SILO'
          })
          showToast(`Error cambiando estado: ${error}`, 'cambioEstadoIncorrecto', 'Cambio de estado', true)(dispatch)
        })
    }
    dispatch({
      type: 'OPEN_DIALOG',
      id: 'CAMBIO_ESTADO_SILO',
      maxWidth: 'xs',
      content: <ConfirmDialogView text={'¿Esta seguro que desea cambiar el estado del silo?'} />,
      cancelCallback,
      confirmCallback
    })
  }
}

export function updateSiloSeleccionado (silo) {
  return dispatch => {
    console.log('updateSiloSeleccionado', silo)
    dispatch({
      type: 'UPDATE_SILO_SELECCIONADO',
      silo
    })
  }
}

export function actualizarEstadoFiltroSilos (cereal, variedad) {
  return dispatch => {
    console.log('actualizando filtros', cereal, variedad)
    dispatch({
      type: 'UPDATE_ESTADO_FILTRADO',
      cereal,
      variedad
    })
  }
}

export function resetEstadoFiltroSilos () {
  return dispatch => {
    console.log('reseteando filtros')
    dispatch({
      type: 'RESET_ESTADO_FILTRADO'
    })
  }
}
